"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const new_item_1 = __importDefault(require("./new-item"));
class NewOccupancySchedule extends new_item_1.default {
    constructor(newOccupancySchedule) {
        super();
        this.name = newOccupancySchedule.name;
        this.schedule = newOccupancySchedule.schedule;
        this.siteIds = newOccupancySchedule.siteIds;
        this._permission = newOccupancySchedule._permission;
    }
}
exports.default = NewOccupancySchedule;
//# sourceMappingURL=new-occupancySchedule.js.map